import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalog-table-toolbar',
  templateUrl: './catalog-table-toolbar.html',
})
export class CatalogTableToolbarComponent {
  @Input({ required: true })
  datatableId = '';

  @Input({ required: true })
  searchPlaceholder = '';

  @Input({ required: true })
  addButtonLabel = '';

  @Input({ required: true })
  addModalId = '';

  @Input({ required: true })
  refreshAriaLabel = '';

  @Input()
  disableRefresh = false;

  @Output()
  refresh = new EventEmitter<void>();
}
